import {useCallback, useState} from 'react';

import {useApi} from '~/modules/api';
import {getErrorMessage} from '~/modules/utils';
import {UserInfo} from '~/types';

export const useUserLookupById = ({userId}: {userId: string}) => {
  const [downloadingUserInfoStatus, setDownloadingUserInfoStatus] = useState<
    'none' | 'requesting' | 'success' | 'error'
  >('none');
  const [downloadingUserInfoErrorMsg, setDownloadingUserInfoErrorMsg] =
    useState('');

  const [userData, setUserData] = useState<UserInfo>();

  const api = useApi();
  const searchUserInfo = useCallback(async () => {
    setDownloadingUserInfoStatus('requesting');
    setDownloadingUserInfoErrorMsg('');
    setUserData(undefined);

    try {
      const {data} = await api.fetch({
        url: '/users/userLookup',
        method: 'POST',
        data: {userId},
      });

      if (data.status !== 'success') {
        throw new Error(data.errorMessage);
      }

      if (!data.data) {
        throw new Error('No data returned for this user');
      }

      setUserData(data.data);
      setDownloadingUserInfoStatus('success');
    } catch (err) {
      setDownloadingUserInfoStatus('error');
      setDownloadingUserInfoErrorMsg(getErrorMessage(err, 'Search failed'));
    }
  }, [api, userId]);

  return {
    downloadingUserInfoErrorMsg,
    downloadingUserInfoStatus,
    userData,
    searchUserInfo,
  };
};
